import React, {useEffect, useState} from "react";
import {LocalStorageService} from "../service/local-storage-service";
import {SessionService} from "../service/session-service";
import ApiService from "../service/api-service";

export const PERMISSIONS = {
    STUDY_LIST: 1,
    STUDY_LIST_DELETED: 2,
    STUDY_DELETE_OR_RESTORE: 3,
    STUDY_SET_READ: 8,
    STUDY_SET_EMERGENCY: 6,
    STUDY_OPEN_VIEWER: 14,
    STUDY_REQUEST_LIST: 4,
    STUDY_REMOVE_READ: 9,
    STUDY_REMOVE_EMERGENCY: 7,
    STUDY_REQUEST_SET: 5,
    STUDY_ANAMNEZ: 26,

    STUDY_FILE_LIST: 28,
    STUDY_FILE_UPLOAD: 29,
    STUDY_FILE_DELETE: 30,
    STUDY_FILE_DOWNLOAD: 31,
    STUDY_FILE_RESTORE_DELETED: 32,
    STUDY_FILE_LIST_DELETED: 33,
    STUDY_CREATE_EMPTY: 42,
    STUDY_CHANGE_INSTITUTION: 44,

    USER_MANAGER: 24,
    REQUEST_TYPE_MANAGER: 23,
    HOSPITAL_MANAGER: 21,
    REPORT_TEMPLATE_MANAGER: 22,

    REPORT_DOWNLOAD_WORD: 18,
    REPORT_REMOVE_CONFIRM: 20,
    REPORT_CONFIRM: 19,
    REPORT_DOWNLOAD_PDF: 17,
    REPORT_LIST: 16,
    REPORT_ADD_OR_EDIT: 25,
    REPORT_HBYS_TRANSFER: 27,
    REPORT_DOWNLOAD_SIGN: 43,
    AI_REPORT_GENERATE: 90,

    VOICE_RECORD_LIST: 10,
    VOICE_RECORD_ADD: 11,
    VOICE_RECORD_OTHER_LIST: 13,
    VOICE_RECORD_DOWNLOAD: 15,
    VOICE_RECORD_DELETE: 12,
    VOICE_RECORD_LIST_DELETED: 37,
    VOICE_RECORD_RESTORE_DELETED: 38,

    STUDY_REQUEST_DELETE: 34,
    STUDY_REQUEST_LIST_DELETED: 35,
    STUDY_REQUEST_RESTORE_DELETED: 36,

    DASHBOARD: 39,

    INSTITUTION_MANAGER: 45,
    STUDY_SET_READ_USER: 47,
    STUDY_GRID_USER_INFO: 48,
    STUDY_ASSIGN_DOCTOR_USER: 49,
    HOSPITAL_GROUP_MANAGER: 50,
    HOSPITAL_GROUP_FILTER: 51,
    HL7_MANAGER: 52,
    STUDY_LOG: 53,
    REPORT_VERSIONS: 54,
    VIEW_STUDY_INSTITUTION: 55,
    EDIT_STUDY_INSTITUTION: 56,
    SHARE_STUDY_BY_EMAIL: 57,
    TELETIP_MANAGER: 58,
    STUDY_ASSIGN_REPORTER_USER: 59,
    REPORT_PREVIEW: 60,
    EXPORT_STUDY: 61,
    
    DEVICE_LIST: 66,
    DEVICE_CREATE_EDIT: 67,
    DEVICE_DELETE: 68,
    WORKLIST_LIST: 69,
    WORKLIST_CREATE_EDIT: 70,
    WORKLIST_DELETE: 71,
    WORKLIST_STATUS_CHANGE: 72,
    STUDY_SHARE: 73,
    INSTITUTION_FILTER: 62,
    MOVE_REQUEST: 63,
    DELETE_STUDY_PERMANENT: 64,
    STUDY_EDIT_METADATA: 65,
    STUDY_MERGE_PATIENT: 74,
    PATIENT_CREATE_EDIT: 75,
    STUDY_MERGE_DELETE_OLD: 76,
    OPEN_LOCKED_STUDY: 77,
    LOCK_STUDY: 78,
    UNLOCK_STUDY: 79,
    VIEW_STUDY_STATUS_HISTORY: 80,
    SET_STUDY_REPORTABLE: 81,
    SET_STUDY_NOT_REPORTABLE: 82,
    STUDY_TASK_MANAGER: 83,
    STUDY_TASK_CREATE_MISSING_DICOM: 84,
    STUDY_TASK_CREATE_RE_ASSESSMENT: 85,
    LOG_MANAGEMENT: 88,
    AUTO_EXPORT_MANAGE: 89,
    REPORT_REMOVE: 91,
    STUDY_ANAMNEZ_EDIT_READ: 92,
    REPORT_REMOVE_SIGN: 93,
    VIEWER_SETTINGS_MANAGER: 94,
    BRANDING_MANAGE: 95,
    CONFIG_MANAGE: 96,

    // Rapor Faturalandırma
    REPORT_BILLING_LIST: 97,
    REPORT_BILLING_EXCEL: 98,
    REPORT_BILLING_STATUS_CHANGE: 99,
    REPORT_BILLING_BULK_APPLY: 100,
    REPORT_BILLING_RECONCILE: 101,
    REPORT_BILLING_FINALIZE: 102,
    REPORT_BILLING_HISTORY: 103,
    REPORT_BILLING_DUPLICATE_DETECT: 104,
    REPORT_BILLING_DELETE_DUPLICATE: 105,
    NOTIFICATION_MANAGE: 106,

    // Çekim Listeleri (backend PermissionItems.cs ile birebir)
    LIST_CREATE: 107,
    LIST_VIEW: 108,
    LIST_ITEM_ADD: 109,
    LIST_VIEW_ALL: 110,

    // Rapor çıktı şablonu builder'ı (backend PermissionItems.cs ile birebir)
    REPORT_OUTPUT_TEMPLATE_MANAGER: 111,
};

const UserActions = {
    SET_USER: 'SET_USER',
    SET_TOKEN: 'SET_TOKEN',
    SET_COOKIE_SESSION: 'SET_COOKIE_SESSION',
    SIGN_OUT: 'SIGN_OUT',
    UPDATE_DICTIONARY: 'UPDATE_DICTIONARY'
}

const defaultValue = {
    // Oturum artık HttpOnly çerezde; `token` yalnız güncelleme öncesinden kalan (ya da sunucuda çerez
    // modu kapalıysa üretilen) token'ı tutar. "Girişli mi?" sorusunun cevabı ikisinin birleşimidir.
    token: LocalStorageService.getToken(),
    cookieSession: SessionService.hasCookieSession(),
    data: LocalStorageService.getUser({
        name: 'test',
        email: 'test',
    }),
    dictionary: []
}

const UserContext = React.createContext(defaultValue);


function userReducer(state, action)
{
    switch (action.type)
    {
        case UserActions.SET_USER: {
            LocalStorageService.setUser(action.data.user)

            return {
                ...state,
                data: action.data?.user,
                dictionary: action.data?.user?.userInformation?.dictionary,
                config: action.data?.config
            }
        }
        case UserActions.SIGN_OUT: {
            // Her iki kimlik de gitmeli: localStorage'daki eski token burada, çerezler ise sunucuda
            // (Auth/Logout) silinir — yoksa sayfa yenilenince işaret çerezi "hâlâ girişli" derdi.
            LocalStorageService.removeToken()
            ApiService.Auth.Logout()

            return {
                ...state,
                token: '',
                cookieSession: false,
                data: {}
            }
        }
        case UserActions.UPDATE_DICTIONARY: {
            return {
                ...state,
                data: {
                    ...state.data,
                    dictionary: action.data || []
                }
            }
        }
        case UserActions.SET_TOKEN: {
            // Giriş yanıtı geldiğinde sunucu çerezi de kurmuş olur. Çerez varsa token'ı SAKLAMAYIZ:
            // localStorage'da durmasının tek sebebi kalırdı ki o da onu XSS'e açık tutmak olurdu.
            //
            // Çerez GÖRÜNMÜYORSA arayüz API ile farklı origin'dedir (geliştirmede localhost:3000):
            // document.cookie başka origin'in çerezini okuyamaz ve tarayıcı onu cross-site XHR'de
            // göndermez. O kurulumda eski token yolu tek çalışan yol olduğu için korunuyor.
            const cookieSession = SessionService.hasCookieSession()

            if (cookieSession) {
                LocalStorageService.removeToken()
            }
            else {
                LocalStorageService.setToken(action.data)
            }

            return {
                ...state,
                token: cookieSession ? '' : action.data,
                cookieSession
            }
        }
        case UserActions.SET_COOKIE_SESSION: {
            // Eski token çereze taşındı (Auth/Session); artık localStorage'da tutulmasına gerek yok.
            LocalStorageService.removeToken()

            return {
                ...state,
                token: '',
                cookieSession: true
            }
        }
        default: {
            return state
        }
    }
}

function UserProvider({children})
{
    const [user, dispatch] = React.useReducer(userReducer, defaultValue)
    const [fetched, setFetched] = useState(false)
    const value = {user, dispatch}

    const getUser = async () => {
        const response = await ApiService.User.Information();
        const resConfig = await ApiService.User.GetConfig();

        if(response.success)
        {
            dispatch({
                type: UserActions.SET_USER,
                data: {
                    user: response.data,
                    config: resConfig.data
                }
            })
        }
    }

    // Oturum çerezde de olabilir, elde kalan eski token'da da.
    const authenticated = !!user.token || user.cookieSession

    useEffect(() => {
        ApiService.setLogout(() => {
            dispatch({
                type: UserActions.SIGN_OUT,
                data: ''
            })
        })
    }, [])

    // Sessiz geçiş: güncellemeden önce girmiş kullanıcının elinde hâlâ geçerli token var, çerezi yok.
    // Token'ı bir kez sunucuya gösterip çereze taşıtıyoruz — kullanıcı hiçbir şey fark etmiyor, kimse
    // yeniden giriş yapmak zorunda kalmıyor. Başarısız olursa (çerez modu kapalı ya da token ölmüş)
    // token yerinde kalır ve istekler eskisi gibi Authorization header'ı ile gider.
    useEffect(() => {
        if (!user.token || user.cookieSession)
            return

        let cancelled = false;

        (async () => {
            const response = await ApiService.Auth.Session()

            if (!cancelled && response?.success && SessionService.hasCookieSession()) {
                dispatch({ type: UserActions.SET_COOKIE_SESSION })
            }
        })()

        return () => { cancelled = true }
    }, [])

    useEffect(() => {
        (async () => {
            if(authenticated && !fetched) {
                await getUser()
                setFetched(true)
            }
            if(!authenticated) {
                setFetched(false)
            }
        })()
    }, [user])

    return (
        <UserContext.Provider value={value}>
            {(fetched || !authenticated) && children}
        </UserContext.Provider>
    )
}

function useUser()
{
    const context = React.useContext(UserContext);

    if(!context)
        throw new Error('User Provider Error')

    const {user, dispatch} = context;

    const setToken = (token) => {
        dispatch({
            type: UserActions.SET_TOKEN,
            data: token
        })
    }

    const updateDictionary = (dictionary) => {
        dispatch({
            type: UserActions.UPDATE_DICTIONARY,
            data: dictionary || []
        })
    }

    const isAuth = () => {
        return !!user.token || !!user.cookieSession;
    }

    const signOut = () => {
        dispatch({
            type: UserActions.SIGN_OUT,
            data: ''
        })
    }

    const hasPermission = (permission) => {
        const config = user?.config

        if([PERMISSIONS.INSTITUTION_MANAGER, PERMISSIONS.VIEW_STUDY_INSTITUTION, PERMISSIONS.EDIT_STUDY_INSTITUTION].includes(permission) && !config?.institutionEnable) {
            return false
        }

        if([PERMISSIONS.SHARE_STUDY_BY_EMAIL].includes(permission) && !config?.emailShareEnable) {
            return false
        }

        if([PERMISSIONS.HL7_MANAGER].includes(permission) && !config?.hl7Enable) {
            return false
        }

        if([PERMISSIONS.TELETIP_MANAGER].includes(permission) && !config?.teletipEnable) {
            return false
        }

        if ([PERMISSIONS.WORKLIST_CREATE_EDIT, PERMISSIONS.WORKLIST_DELETE, PERMISSIONS.WORKLIST_LIST, PERMISSIONS.WORKLIST_STATUS_CHANGE].includes(permission) && !config?.worklistEnable) {
            return false
        }

        if(!user.data || !user.data.permissionIdList || !user.data.role || !user.data.role.permissionIdList)
        {
            return false;
        }


        return (user.data.permissionIdList.includes(permission) || user.data.role.permissionIdList.includes(permission))
    }

    const showDashboard = (type) => {
        switch (type) {
            case 'admin': {
                return (hasPermission(PERMISSIONS.DASHBOARD))
            }
            case 'doctor': {
                return (hasPermission(PERMISSIONS.DASHBOARD) || hasPermission(PERMISSIONS.VOICE_RECORD_ADD))
            }
            case 'reporter': {
                return (hasPermission(PERMISSIONS.DASHBOARD) || hasPermission(PERMISSIONS.REPORT_ADD_OR_EDIT))
            }
            default: {
                return (hasPermission(PERMISSIONS.DASHBOARD) || hasPermission(PERMISSIONS.VOICE_RECORD_ADD) || hasPermission(PERMISSIONS.REPORT_ADD_OR_EDIT))
            }
        }
    }

    return {
        user,
        dictionary: user?.dictionary,
        modalities: user?.modalities || [],
        config: user?.config,
        setToken,
        isAuth,
        signOut,
        hasPermission: (permission) => {
            return hasPermission(permission)
        },
        showDashboard,
        updateDictionary,
    }
}

export {UserProvider, useUser}

